<template>
  <div>
    <b-carousel
      id="team-carousel"
      v-model="slide"
      :interval="4000"
      :controls="enableControls"
      indicators
      background="#ababab"
      img-width="1024"
      img-height="480"
    >
      <b-carousel-slide
        v-for="(slide, i) in items"
        :key="'teamCarouselSlide' + i"
      >
        <b-row class="w-100 flex-grow-1">
          <b-col sm="4" v-for="member in slide" :key="member.name + i">
            <b-card
              :title="member.name"
              :img-src="member.professionalProfile"
              :img-alt="`Avatar ${member.name}`"
              img-top
              tag="article"
              class="smooth-shadow"
              @click="emitClick(member.id)"
            >
              <b-card-text>{{ member.position }}</b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import { checkIsMobile } from "@/utils/checkIsMobile.js";

export default {
  name: "TeamCarousel",
  props: {
    team: Array
  },
  data() {
    return {
      slide: 0
    };
  },
  methods: {
    emitClick(id) {
      this.$emit("clickMember", id);
    }
  },
  computed: {
    items: function () {
      const tmpArr = [];
      let arrCounter = 0;
      let isMobile = checkIsMobile();

      if (!isMobile || window.screen.width > 420) {
        tmpArr.push([]);

        for (let i = 0; i < this.team.length; i++) {
          if (i > 0 && i % 3 === 0) {
            arrCounter = ++arrCounter;
            tmpArr.push([]);
          }
          tmpArr[arrCounter].push(this.team[i]);
        }
        return tmpArr;
      } else {
        this.team.forEach((item) => {
          tmpArr.push([item]);
        });
        return tmpArr;
      }
    },
    enableControls: function () {
      let tmpItems = this.items.flat();
      if (tmpItems && tmpItems.length <= 3) return false;
      return true;
    }
  }
};
</script>

<style lang="sass">
#team-carousel
  background: transparent !important
  .carousel
    &-inner
      width: 80%
      margin: 0 auto 3rem
      @media screen and (max-width: 820px)
        width: 100%
    &-caption
      position: relative
      display: flex
      flex-direction: row
      justify-content: space-between
      color: inherit
      left: 0
      right: 0
      bottom: 0
      padding: 0
      margin: 1rem 2rem 2rem
      @media screen and (max-width: 502px)
        margin: 1rem 0
        justify-content: center
    &-item
      background: transparent !important
      .card
        position: relative
        border-radius: 0
        border: 1px solid rgba(0, 0, 0, 0.075)
        &:hover, &:active
          cursor: pointer
          .card-body:after
            content: 'Ver más'
            position: absolute
            top: 0
            left: 0
            width: 100%
            transform: translateY(-100%)
            padding: 1rem 0.5rem 0.5rem
            color: white
            background: rgba(2,0,36,0.2)
            background: linear-gradient(0deg, rgba(85,91,80,0.65) 0%, rgba(85,91,80,0.5) 35%, rgba(85,91,80,0) 100%)
            font-size: 14px
            letter-spacing: 1px
        &-img-top
          border-radius: 0
        &-body
          position: relative
          min-height: 130px
        &-title
          font-size: 1.3rem
    &-control-prev
      justify-content: flex-start
      width: 10%
      z-index: 999
      &-icon
        width: 40px
        height: 40px
        // eslint-disable-next-line
        background-image: url('~@/assets/slider-nav-arrow.svg')
    &-control-next
      justify-content: flex-end
      width: 10%
      z-index: 999
      &-icon
        width: 40px
        height: 40px
        // eslint-disable-next-line
        background-image: url('~@/assets/slider-nav-arrow.svg')
        transform: rotate(180deg)
    &-indicators
      margin: 0
      bottom: -3rem
      opacity: 0.75
      transition: opacity 300ms ease
      @media screen and (max-width: 502px)
        bottom: -2.5rem
      &:hover
        opacity: 1
      li
        outline: none
        background-color: #ACB7A1
        width: 1rem
        height: 1rem
        border-radius: 50%
        margin: 0 0.5rem
        @media screen and (max-width: 502px)
          width: 0.75rem
          height: 0.75rem
          margin: 0 0.25rem
</style>
